import { render, staticRenderFns } from "./SectionHeaderV1.vue?vue&type=template&id=d06be8bc&"
import script from "./SectionHeaderV1.vue?vue&type=script&lang=js&"
export * from "./SectionHeaderV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports